<template lang="pug">
.faq
  banner(:background="bannerImage", :title="title")
  .py-5.bg-light
    .container
      h1.text-center.mt-5 How can we help you?
      .mx-auto.col-md-6.py-5
        .input-group.input-group-lg.input-search
          input.form-control(
            v-model="keyword",
            type="text",
            placeholder="Please enter key words",
            aria-label="Please enter key words",
            aria-describedby="button-addon2"
          )
          .input-group-append
            button#button-addon2.btn.btn-outline-secondary(
              type="button",
              @click="search"
            )
              font-awesome-icon(:icon="['fas', 'search']") 
      h3.my-4 Frequently Asked Questions
      faq-item(
        v-for="(category, index) in currentFAQList",
        :key="index",
        :title="category.title",
        :questionList="category.questions",
        @toDetail="toDetail"
      )
      nav.my-5(aria-label="Page navigation example")
        b-pagination.justify-content-center.mb-5(
          v-model="currentPage",
          :total-rows="pages",
          :per-page="perPage",
          first-number,
          last-number,
          prev-text="Previous",
          next-text="Next"
        )
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
    font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
    | PCAP IC selector
  custom-footer
</template>

<script>
import Banner from "@/components/news_detail/Banner";
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import FaqItem from "@/components/faq/Faq";
import { getFAQInformation, getFAQList } from "@/api/company";

export default {
  name: "Faq",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  components: {
    Banner,
    "custom-footer": Footer,
    FloatTop,
    FloatActions,
    FaqItem,
  },
  data() {
    return {
      title: "FAQ",
      bannerImage: "",
      keyword: "",
      FAQList: [],
      currentFAQList: [],

      isExpand: false,
      pages: 1,
      perPage: 3,
      currentPage: 1,

      metaData: {
        title: "FAQ ｜EETI – Empower TouchSystem",
      },
    };
  },
  watch: {
    currentPage() {
      this.getCurrentFAQList();
    },
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getFAQList();
      this.getFAQInformation();
    },
    getFAQInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getFAQInformation(temp).then((response) => {
        this.bannerImage = response.data.photo.image;
        this.title = response.data.title;
      });
    },
    getFAQList() {
      let temp = {
        lang: this.$store.state.user.language,
        keyword: this.keyword,
      };
      getFAQList(temp).then((response) => {
        this.FAQList = response.data;
        this.getCurrentFAQList();
      });
    },
    getCurrentFAQList() {
      this.currentFAQList = [];
      let number = this.perPage * this.currentPage;
      this.pages = this.FAQList.length;
      this.currentFAQList = this.FAQList.slice(number - this.perPage, number);
    },
    toDetail(id) {
      this.$router.push({
        name: "FaqDetail",
        params: {
          id: id,
        },
      });
    },
    search() {
      this.getFAQList();
    },
  },
};
</script>
<style lang="scss" scoped>
.input-search {
  border: #ccc 1px solid;
  .form-control {
    border: none;
    border-radius: 0;
    font-weight: 300;
  }
  .btn {
    color: rgba(8, 43, 107, 0.3);
    background-color: #fff;
    border: none;
    border-radius: 0 !important;
    &:hover {
      color: rgba(8, 43, 107, 1);
    }
  }
}
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.form-control::placeholder {
  color: #bac0ce;
}
::v-deep .page-item.active .page-link {
  background-color: #082b6b;
  border-color: #082b6b;
}
::v-deep .page-link {
  color: #082b6b;
  font-weight: 300;
}
::v-deep .pagination .page-item {
  margin-right: 0.5rem;
  font-weight: 300;
}
</style>